<template>
    <span>
        <svg-icon width="24" height="24" viewBox="0 0 24 24" iconName="mail-icon">
           <path d="M23.0027 5.12524L16.2092 11.875L23.0027 18.6247C23.1255 18.368 23.2 18.0842 23.2 17.7812V5.9687C23.2 5.66564 23.1255 5.38193 23.0027 5.12524Z" :fill="fill"/>
            <path d="M21.2313 4H2.76875C2.46569 4 2.18197 4.07451 1.92529 4.19731L10.6081 12.8363C11.3758 13.6041 12.6242 13.6041 13.392 12.8363L22.0747 4.19731C21.818 4.07451 21.5343 4 21.2313 4Z" :fill="fill"/>
            <path d="M0.997362 5.12524C0.874555 5.38193 0.800049 5.66564 0.800049 5.9687V17.7812C0.800049 18.0843 0.874555 18.368 0.997362 18.6247L7.79082 11.875L0.997362 5.12524Z" :fill="fill"/>
            <path d="M15.2813 12.8031L14.3199 13.7644C13.0407 15.0436 10.9592 15.0436 9.68003 13.7644L8.71876 12.8031L1.92529 19.5528C2.18197 19.6756 2.46569 19.7501 2.76875 19.7501H21.2313C21.5343 19.7501 21.818 19.6756 22.0747 19.5528L15.2813 12.8031Z" :fill="fill"/>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-mail',
    computed: {
        fill() {
            return this.active ? '#fff' : 'url(#red-light)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        active: {
            type: Boolean,
            default: false
        }
    },
}
</script>